<template>
	<div class="sidebar">
		<nav class="sidebar-nav">
			<ul class="nav">
				<li class="nav-title">Menú</li>
				<li class="nav-item">
					<a class="nav-link" href="/dashboard">
						<i class="nav-icon cui-speedometer"></i> DashBoard
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/accounts">
						<i class="nav-icon cui-layers"></i> Sucursales
					</a>
				</li>
				<li class="nav-item nav-dropdown">
					<a class="nav-link nav-dropdown-toggle" href="#">
						<i class="nav-icon cui-puzzle"></i> Nav dropdown
					</a>
					<ul class="nav-dropdown-items">
						<li class="nav-item">
							<a class="nav-link" href="#">
								<i class="nav-icon cui-puzzle"></i> Nav dropdown item
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#">
								<i class="nav-icon cui-puzzle"></i> Nav dropdown item
							</a>
						</li>
					</ul>
				</li>
			</ul>
		</nav>
		<!--<button class="sidebar-minimizer brand-minimizer" type="button"></button>-->
	</div>
</template>

<script>
	export default {
		name: "SPCSideBar"
	}
</script>

<style scoped>

</style>
